SA.BackNavigationHandler = {
    initialize() {
        if (history.length === 1) {
            return;
        }

        this.pushDummyHistoryEntry(); 

        this.initEvents();
    },

    initEvents() {
        this.onPopState = this.onPopState.bind(this);

        window.addEventListener('popstate', this.onPopState);
        window.addEventListener('pageshow', this.onPageShow.bind(this));
    },

    onLeavePageRequested() {
        window.removeEventListener('popstate', this.onPopState);

        navigateBackRecursive();

        function navigateBackRecursive() {
            window.addEventListener('popstate', function() {
                history.back();
            });

            history.back();
        }
    },

    onPageShow(e) {
        if (e.persisted) {
            window.location.reload();
        }
    },

    onPopState() {
        this.pushDummyHistoryEntry();

        this.showPopup();
    },

    pushDummyHistoryEntry() {
        history.pushState(null, null);
    },

    showPopup() {
        if (this.popup) {
            return;
        }

        this.popup = Ext.widget({
            xtype: 'back-navigation-popup',

            listeners: {
                'request:leave': () => {
                    this.onLeavePageRequested();
                },

                'request:stay': () => {
                    this.popup = null;
                }
            }
        });
    }
};